import type { MoveQualityCounts } from 'endchess-contracts';

export type MoveQualityKey = keyof MoveQualityCounts;

export const MOVE_QUALITY_ORDER: MoveQualityKey[] = [
  'best',
  'strong',
  'inaccuracy',
  'mistake',
  'blunder',
];

export const MOVE_QUALITY_LABELS: Record<MoveQualityKey, string> = {
  best: 'Best',
  strong: 'Strong',
  inaccuracy: 'Inaccuracy',
  mistake: 'Mistake',
  blunder: 'Blunder',
};

export const MOVE_QUALITY_BUBBLE_STYLES: Record<
  MoveQualityKey,
  { bgcolor: string; color: string }
> = {
  best: { bgcolor: '#2e7d32', color: '#ffffff' },
  strong: { bgcolor: '#a5d6a7', color: '#1b5e20' },
  inaccuracy: { bgcolor: '#fdd835', color: '#4e342e' },
  mistake: { bgcolor: '#fb8c00', color: '#ffffff' },
  blunder: { bgcolor: '#e53935', color: '#ffffff' },
};
